import React, { createContext, useContext } from 'react'
import { useFormikContext } from 'formik'

export interface PreviewFormValues {
  previewName: string
  description: string
  inspectEnabled: boolean
  commentsEnabled: boolean
  passwordProtected: boolean
  password: string
  hasExistingPassword: boolean
  expiryDate: string
  expiryDateEnabled: boolean
  selectedUUIDs: { uuid: string; type: 'PAGE' | 'PROTOTYPE' }[]
}

interface PreviewFormContextType {
  formik: ReturnType<typeof useFormikContext<PreviewFormValues>>
  previewIdentifier?: string
  setPreviewIdentifier: (identifier?: string) => void
}

const PreviewFormContext = createContext<PreviewFormContextType | null>(null)

export const usePreviewForm = () => {
  const context = useContext(PreviewFormContext)
  if (!context) {
    throw new Error('usePreviewForm must be used within a PreviewFormProvider')
  }
  return {
    ...context.formik,
    previewIdentifier: context.previewIdentifier,
    setPreviewIdentifier: context.setPreviewIdentifier,
  }
}

export const PreviewFormProvider = ({
  children,
  previewIdentifier,
  setPreviewIdentifier,
}: {
  children: React.ReactNode
  previewIdentifier?: string
  setPreviewIdentifier: (identifier?: string) => void
}) => {
  const formikContext = useFormikContext<PreviewFormValues>()
  return (
    <PreviewFormContext.Provider
      value={{
        formik: formikContext,
        previewIdentifier,
        setPreviewIdentifier,
      }}
    >
      {children}
    </PreviewFormContext.Provider>
  )
}
